import './LogoHomeLink.scss';

import cn from 'classnames';
import React from 'react';
import { NavLink } from 'react-router-dom';

import { ROUTE_HOME } from '@/common/constants';
import useTheme from '@/common/hooks/useTheme';

import {
  LogoHomeLinkDefaultProps,
  LogoHomeLinkPropTypes,
} from './LogoHomeLink.proptypes';

const LogoHomeLink = ({ className }) => {
  const { Logo: ImgLogo } = useTheme();

  return (
    <NavLink
      className={cn(className, 'logo-home-link')}
      to={ROUTE_HOME}
      data-qa-id="logo-home-link"
    >
      <ImgLogo className="logo-home-link__img" />
    </NavLink>
  );
};

LogoHomeLink.defaultProps = {
  ...LogoHomeLinkDefaultProps,
};

LogoHomeLink.propTypes = {
  ...LogoHomeLinkPropTypes,
};

export default LogoHomeLink;
